export const computeWidthToScroll = (
  numberOfRaces: number,
  scrollWidth: number | undefined,
  clientWidth: number | undefined
) => {
  let widthToScroll = 0;

  if (scrollWidth && numberOfRaces && clientWidth) {
    const raceWidth = scrollWidth / numberOfRaces;
    const numberOfRacesToDisplay = Math.floor(clientWidth / raceWidth) - 1;
    widthToScroll = raceWidth * numberOfRacesToDisplay;
  }
  return widthToScroll;
};
